module.exports = __webpack_public_path__ + "img/17.0e0eb96b.png";